import { render } from "./PromotionProductListComponent.vue?vue&type=template&id=46a3737f"
import script from "./PromotionProductListComponent.vue?vue&type=script&lang=js"
export * from "./PromotionProductListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/promotions/product/PromotionProductListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46a3737f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46a3737f', __exports__)) {
    api.reload('46a3737f', __exports__)
  }
  
  module.hot.accept("./PromotionProductListComponent.vue?vue&type=template&id=46a3737f", () => {
    api.rerender('46a3737f', render)
  })

}


export default __exports__